export default class SubMenu {
  constructor(element) {
    this.element = element;
    this.button = element.querySelector('.js-sub-menu-btn');
    this.list = element.querySelector('.js-sub-menu-list');
    this.listItems = Array.from(this.list.querySelectorAll('li'));
    this.isOpen = false;

    this.init();
  }

  static instances = new WeakMap();

  init() {
    SubMenu.instances.set(this.element, this);

    this.list.setAttribute('aria-expanded', false);
    this.button.addEventListener('click', this.toggleMenu);
  }

  toggleMenu = (e) => {
    e.preventDefault();

    this.isOpen = !this.isOpen;

    this.button.setAttribute('aria-expanded', this.isOpen);
    this.element.classList.toggle('is-open');
  };

  unmount() {
    this.button.removeEventListener('click', this.toggleMenu);
    this.button.removeAttribute('aria-expanded');
    this.isOpen = false;

    SubMenu.instances.delete(this.element);
  }
}
